import React from 'react';
import './IndustryReferences.css';

const IndustryReferences = () => {
  const networks = [
    {
      id: 1,
      name: 'WCA Network',
      description: 'WCA is a global freight forwarder network connecting professionals across 190+ countries, enabling strong partnerships and efficient, reliable cross-border logistics operations.',
      website: 'https://www.wcaworld.com/',
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <circle cx="12" cy="12" r="10"/>
          <path d="M2 12h20"/>
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
        </svg>
      )
    },
    {
      id: 2,
      name: 'Magenta Logistics Network',
      description: 'Magenta Logistics Network connects trusted companies globally, enabling collaboration, strategic partnerships, stronger operations, expanded market reach, and sustainable business growth opportunities.',
      website: 'https://www.magentalogisticsnetwork.com/',
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M12 2L2 7l10 5 10-5-10-5z"/>
          <path d="M2 17l10 5 10-5"/>
          <path d="M2 12l10 5 10-5"/>
        </svg>
      )
    },
    {
      id: 3,
      name: 'Atlas Logistics Network',
      description: 'Atlas Logistics Network connects freight forwarders globally, enabling strong partnerships, international expansion, effective collaboration, and sustainable growth across diverse logistics markets worldwide.',
      website: 'https://www.atlas-network.com/',
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
          <circle cx="12" cy="10" r="3"/>
        </svg>
      )
    },
    {
      id: 4,
      name: 'Globalia Logistics Network',
      description: 'Globalia Logistics Network connects independent freight forwarders with trusted global partners, enabling collaboration, stronger presence, and sustainable business growth worldwide.',
      website: 'https://www.globalialogisticsnetwork.com/',
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <rect x="3" y="3" width="18" height="18" rx="2"/>
          <path d="M3 9h18"/>
          <path d="M3 15h18"/>
          <path d="M9 3v18"/>
          <path d="M15 3v18"/>
        </svg>
      )
    }
  ];

  return (
    <section className="industry-references-section">
      <div className="container">
        {/* Section Header */}
        <div className="section-header">
          <h2 className="section-title">Leading Global Logistics Networks</h2>
          <p className="section-subtitle">
            Powering the logistics industry through trusted connections that unite freight forwarders and companies worldwide.
          </p>
        </div>

        {/* Networks Grid */}
        <div className="networks-grid">
          {networks.map((network) => (
            <div key={network.id} className="network-card hover-lift">
              <div className="network-icon-wrapper">
                <div className="network-icon">
                  {network.icon}
                </div>
              </div>
              <h3 className="network-name">{network.name}</h3>
              <p className="network-description">{network.description}</p>
              <a 
                href={network.website} 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn-visit-website"
              >
                Visit Website
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
                  <polyline points="15 3 21 3 21 9"/>
                  <line x1="10" y1="14" x2="21" y2="3"/>
                </svg>
              </a>
            </div>
          ))}
        </div>

        {/* Trust Message */}
        <div className="trust-message">
          <p>
            EFFN is built on proven global logistics network models, creating a strong platform for freight forwarders to collaborate, expand, and grow their businesses worldwide.
            The network fosters trusted partnerships, enabling members to strengthen operations, access new markets, and achieve sustainable international growth.
          </p>
        </div>
      </div>
    </section>
  );
};

export default IndustryReferences;
